import { useEffect } from 'react';
import { UserStatus } from '@types';
import { CheckboxInput } from '@components';
import { useController } from 'react-hook-form';
import WarningIcon from '@mui/icons-material/Warning';
import Checkbox from '@mui/material/Checkbox';

import cls from './UserStatusForm.module.css';

const userStatuses = ['active', 'inactive'];

interface Props {
  hasLogged?: boolean;
}

export const UserStatusForm = ({ hasLogged }: Props) => {
  const {
    field: { value: status, onChange: setStatus },
  } = useController({ name: 'status' });
  const {
    field: { value: isActive, onChange: setActive },
  } = useController({ name: 'isActive' });
  const {
    field: { value: isInactive, onChange: setInactive },
  } = useController({ name: 'isInactive' });

  useEffect(() => {
    if (isInactive && status !== UserStatus.INACTIVE) {
      setStatus(UserStatus.INACTIVE);
      setActive(false);
    }
    if (status === UserStatus.INACTIVE) {
      setStatus(UserStatus.INACTIVE);
      setActive(false);
      setInactive(true);
    }
  }, [isActive, isInactive]);

  return (
    <div className={cls.form}>
      {userStatuses.includes(status) && (
        <>
          <div className={cls.check}>
            <Checkbox size="small" checked={isActive} />
            <span className={cls.checkLabel}>Active</span>
          </div>
          <CheckboxInput source="isInactive" label="Inactive" className={cls.check} />
        </>
      )}

      {status === 'not_available' && (
        <>
          <div className={cls.check}>
            <Checkbox size="small" checked={isActive} />
            <span className={cls.checkLabel}>Active</span>
          </div>
          <div className={cls.check}>
            <Checkbox size="small" checked={isInactive} />
            <span className={cls.checkLabel}>Inactive</span>
          </div>
          {!hasLogged && (
            <div className={cls.warning}>
              <WarningIcon style={{ color: 'var(--primary-color)' }} /> Client has not logged in yet
            </div>
          )}
        </>
      )}
    </div>
  );
};
